module.exports = __webpack_public_path__ + "static/media/promo-v2-6.e76abff9.jpeg";